/**
 * @module 通知履歴メッセージ部共通コンポーネント
 */
import ListPanel from '../listPanel/ListPanel.vue';
import CONSTANTS from '../../constants';
import nativeApi from '../../api/nativeApi';

export default {
  name: 'NotificationHistoryTimeline',
  components: {
    ListPanel,
  },
  props: {
    displaySelectorList: {
      type: Array,
    },
    lastUpdate: {
      type: String,
    },
    panelTitle: {
      type: Object,
    },
    displayAreaList: {
      type: Array,
    },
    homeSecurityChecked: {
      type: Boolean,
      default: true,
    },
    cameraChecked: {
      type: Boolean,
      default: true,
    },
    noticeChecked: {
      type: Boolean,
      default: true,
    },
    tabSelect: {
      type: Number,
      default: 1,
    },
    lastUpdateFlag: {
      type: Boolean,
      default: false,
    },
    cameraDetailFlag: {
      type: Boolean,
      default: false,
    },
    notificationHistoryFlag: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectorList: [],
      onlyOnce: false,

      page: 1,
      length: 0,
      lists: [],
      displayLists: [],
      pageSize: 200,
      isShow: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        messageNumber4f: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.見守り監視は'
        ),
        messageNumber4b: vm.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.通知メッセージ.です'),
        messageNumber6f: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.見守り監視は'
        ),
        messageNumber6b: vm.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.通知メッセージ.です'),
        messageNumber9f: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.見守り監視に'
        ),
        messageNumber9b: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.が発生しています'
        ),
        messageNumber17b: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.になりました'
        ),
        messageNumber101f: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.カメラが'
        ),
        messageNumber101b: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.になりましたC'
        ),
        messageNumberDetail: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.詳細は'
        ),
        messageNumberThis: vm.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.通知メッセージ.コチラ'),
        newMessage: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.前回ログイン以降の通知'
        ),
        showPreviousNotifications: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.以前の通知を表示'
        ),
        showLaterNotifications: vm.$vuetify.lang.t(
          '$vuetify.FECU17通知履歴画面.通知メッセージ.以降の通知を表示'
        ),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * ページ切替
     * @param {number} pageNumber 選択したページ
     */
    pageChange: function (pageNumber) {
      if (this.selectorList.length % this.pageSize !== 0) {
        for (let i = 0; i < this.selectorList.length % this.pageSize; i++) {
          this.selectorList.unshift({});
        }
      }
      this.displayLists = this.selectorList.slice(
        this.pageSize * (pageNumber - 1),
        this.pageSize * pageNumber
      );
    },
    /**
     * メッセージの表示制御、整形
     */
    listReset: function () {
      let select = this.tabSelect;
      let bfPostedDate = ''; // 一つ前の日付が同じか判定用
      let days = [
        '$vuetify.コード.曜日.日',
        '$vuetify.コード.曜日.月',
        '$vuetify.コード.曜日.火',
        '$vuetify.コード.曜日.水',
        '$vuetify.コード.曜日.木',
        '$vuetify.コード.曜日.金',
        '$vuetify.コード.曜日.土',
      ];
      let notificationEmptyFlg = true;

      if (this.displaySelectorList) {
        this.selectorList = [];
        for (var idx = 0; idx < this.displaySelectorList.length; idx++) {
          let element = this.displaySelectorList[idx];

          if (this.$mq === 'pc') {
            // PC
            if (
              (this.homeSecurityChecked == false && element.notificationType == 1) ||
              (this.cameraChecked == false && element.notificationType == 2) ||
              (this.noticeChecked == false && element.notificationType == 3)
            ) {
              continue;
            }
          } else {
            // SP
            if (
              select == 0 ||
              (select == 1 && element.notificationType == 1) ||
              (select == 2 && element.notificationType == 2) ||
              (select == 3 && element.notificationType == 3)
            ) {
              // 表示する
            } else {
              // 表示しない
              continue;
            }
          }

          notificationEmptyFlg = false;

          // アバターアイコンに表示する名前を作成
          let firstString = '';
          let lastString = '';
          // 半角スペース
          let spaceHalf = element.postedName.indexOf(' ');
          // 全角スペース
          let spaceFull = element.postedName.indexOf('　');

          firstString = element.postedName.slice(0, 1);
          if (spaceHalf > 0 && spaceFull > 0) {
            if (spaceHalf <= spaceFull) {
              lastString =
                spaceHalf !== -1 ? element.postedName.slice(spaceHalf + 1, spaceHalf + 2) : '';
            } else {
              lastString =
                spaceFull !== -1 ? element.postedName.slice(spaceFull + 1, spaceFull + 2) : '';
            }
          } else if (spaceHalf > 0 || spaceFull > 0) {
            if (spaceHalf > 0) {
              lastString =
                spaceHalf !== -1 ? element.postedName.slice(spaceHalf + 1, spaceHalf + 2) : '';
            } else {
              lastString =
                spaceFull !== -1 ? element.postedName.slice(spaceFull + 1, spaceFull + 2) : '';
            }
          } else {
            lastString = element.postedName.slice(1, 2);
          }

          // 日付を作成
          let date = new Date(element.postedDatetime.slice(0, 10));

          let postedDate = date.getMonth() + 1 + '/' + date.getDate();
          let postedDay = days[date.getDay()];

          // 日付が同じである場合は日付を表示しない
          let postedDateDisplayFlag = true;
          if (this.displaySelectorList[idx - 1] !== undefined && postedDate === bfPostedDate) {
            postedDateDisplayFlag = false;
          } else {
            bfPostedDate = postedDate;
          }

          // 通知の色とメッセージ内容とリンク先を設定
          let notificationColor = '';
          let message1 = '';
          let message2 = '';
          let messageNumber = 1;
          let messageArgument = 2; //1:カメラニックネーム 2:センサー名称 3:操作者情報 4:警備先名称
          let remarks = ''; // 空でない場合に表示するメッセージ
          let underline = false; // アンダーラインの有無
          let bold = false; // 太字の有無

          switch (element.serviceType) {
            case 'N01':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.N01;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.侵入警報';
              break;
            case 'A01':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A01;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A01;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.火災警報';
              break;
            case 'A02':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A02;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A02;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.ガス警報';
              break;
            case 'A19':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A19;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A19;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.CO警報';
              break;
            case 'A03':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A03;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A03;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.非常警報';
              break;
            case 'A04':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A04;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A04;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.救急警報';
              break;
            case 'A09':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A09;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A09;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.ライフリズム警報';
              break;
            case 'A05':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A05;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A05;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.設備警報';
              break;
            case 'A06':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A06;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A06';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A06;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.停電警報';
              break;
            case 'A07':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A07;
                messageNumber = 17;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A07';
                underline = true;
                bold = true;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A07;
                messageNumber = 12;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.ローバッテリー';
              break;
            case 'A08':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A08;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A08';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A08;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.保護警報';
              break;
            case 'A10':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A10;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A10';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A10;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.警備ユニット異常';
              break;
            case 'A11':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A11;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A11';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A11;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.警備ユニット異常';
              break;
            case 'A12':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A12;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A12';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A12;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.警備ユニット異常';
              break;
            case 'A17':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A17;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A17';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A17;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.端末異常警報';
              break;
            case 'A18':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A18;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A18';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A18;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.無線端末異常';
              break;
            case 'A15':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A15;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A15';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A15;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.機器故障';
              break;
            case 'A16':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A16;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A16';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A16;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.メッセージ認証不一致';
              break;
            case 'A13':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A13;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A13';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A13;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.通信異常';
              break;
            case 'A14':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.A14;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.A14';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.A14;
                messageNumber = 16;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.断線';
              break;
            case 'S03':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.S03;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.外出ALSOK警備';
              messageNumber = 3;
              messageArgument = 3;
              break;
            case 'S05':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.S05;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.在宅ALSOK警備';
              messageNumber = 3;
              messageArgument = 3;
              break;
            case 'S04':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.S04;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.外出セルフ警備';
              messageNumber = 3;
              messageArgument = 3;
              break;
            case 'S06':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.S06;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.在宅セルフ警備';
              messageNumber = 3;
              messageArgument = 3;
              break;
            case 'S07':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.S07;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.警備解除';
              messageNumber = 15;
              messageArgument = 3;
              break;
            case 'S08':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.S08;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.強制警備';
              messageNumber = 3;
              messageArgument = 3;
              break;
            case 'M02':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.M02;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.M02';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.M02;
                messageNumber = 12;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.電池電圧低下';
              messageArgument = 2;
              break;
            case 'M03':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.M03;
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.M03';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.M03;
                messageNumber = 12;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.過負荷';
              messageArgument = 2;
              break;
            case 'J02':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.J02;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.異常';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定期通報';
              messageNumber = 13;
              messageArgument = 2;
              break;
            case 'J04':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.J04;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.異常';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定刻通報';
              messageNumber = 13;
              messageArgument = 2;
              break;
            case 'J06':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.J06;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.異常';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.異常通報';
              messageNumber = 13;
              messageArgument = 2;
              break;
            case 'J10':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.J10;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.監視停止中';
              messageNumber = 6;
              messageArgument = 2;
              underline = true;
              bold = true;
              break;
            case 'J11':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.J11;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定刻異常中';
              messageNumber = 6;
              messageArgument = 2;
              underline = true;
              bold = true;
              break;
            case 'J13':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.J13;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.見守り操作忘れ異常通報';
              messageNumber = 9;
              messageArgument = 2;
              underline = true;
              bold = true;
              break;
            case 'J01':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J01;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.正常';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定期連絡';
              messageNumber = 4;
              underline = true;
              bold = true;
              break;
            case 'J03':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J03;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.復旧';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定期連絡';
              messageNumber = 10;
              messageArgument = 2;
              break;
            case 'J05':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J05;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.復旧';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定刻連絡';
              messageNumber = 10;
              messageArgument = 2;
              break;
            case 'J07':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J07;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.復旧';
              message2 = '$vuetify.FECU17通知履歴画面.通知メッセージ.異常通知';
              messageNumber = 10;
              messageArgument = 2;
              break;
            case 'J08':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J08;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.見守り監視';
              messageNumber = 3;
              messageArgument = 2;
              break;
            case 'J09':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J09;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.見守り監視';
              messageNumber = 14;
              messageArgument = 2;
              break;
            case 'J16':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J16;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.定刻正常';
              messageNumber = 6;
              messageArgument = 2;
              underline = true;
              bold = true;
              break;
            case 'J12':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J12;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.設定変更完了';
              messageNumber = 18;
              messageArgument = 2;
              break;
            case 'J14':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J14;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.強制監視停止状態';
              messageNumber = 6;
              messageArgument = 2;
              underline = true;
              bold = true;
              break;
            case 'J15':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.J15;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.強制監視停止状態';
              messageNumber = 19;
              messageArgument = 2;
              break;
            case '001':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.C001;
              messageNumber = 100;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.動体検知';
              messageArgument = 1;
              break;
            case '002':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.C002;
                messageNumber = 101;
                remarks = this.$vuetify.lang.t('$vuetify.FECU17通知履歴画面.通知メッセージ.002');
                underline = true;
                bold = true;
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.C002;
                messageNumber = 102;
              }
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.ローバッテリー';
              messageArgument = 1;
              break;
            case '003':
              if (element.contentType == 1) {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE.C003;
                messageNumber = 101;
                message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.オフライン';
                remarks = '$vuetify.FECU17通知履歴画面.通知メッセージ.003';
              } else {
                notificationColor = CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE0.SERVICE_TYPE.C003;
                messageNumber = 101;
                message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.オンライン';
              }
              messageArgument = 1;
              bold = true;
              underline = true;
              break;
            case 'HSAPP1':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.USER_SECURITY.HSAPP1;
              messageNumber = 200;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.外出ALSOK警備操作';
              messageArgument = 0;
              break;
            case 'HSAPP2':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.USER_SECURITY.HSAPP2;
              messageNumber = 200;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.在宅ALSOK警備操作';
              messageArgument = 0;
              break;
            case 'HSAPP3':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.USER_SECURITY.HSAPP3;
              messageNumber = 200;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.外出セルフ警備操作';
              messageArgument = 0;
              break;
            case 'HSAPP4':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.USER_SECURITY.HSAPP4;
              messageNumber = 200;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.在宅セルフ警備操作';
              messageArgument = 0;
              break;
            case 'HSAPP5':
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.USER_SECURITY.HSAPP5;
              messageNumber = 200;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.警備解除操作';
              messageArgument = 0;
              break;
            default:
              messageNumber = 999;
              notificationColor = CONSTANTS.NOTIFICATION_HISTORY.ALSOK;
              message1 = '$vuetify.FECU17通知履歴画面.通知メッセージ.ALSOKからのお知らせ';
              underline = true;
              messageArgument = 0;
              break;
          }

          // 詳細はこちらの部分を置き換え
          if (element.notificationType == 3 && this.existsLink(element.notificationMessage)) {
            let message = element.notificationMessage;
            var splitBf = message.split('<a');
            var splitMi = splitBf[1].split('">');
            var splitAf = splitMi[1].split('</a>');

            element.notificationMessageBf = splitBf[0];
            element.notificationMessageLink = splitAf[0];
            element.notificationMessageAf = splitAf[1];
          }

          // 表示する通知に以下の項目を追加
          element.id = idx;
          element.postedNickname = firstString + lastString;
          element.postedDate = postedDate;
          element.postedDay = postedDay;
          element.postedDateDisplayFlag = postedDateDisplayFlag;
          element.postedTime = element.postedDatetime.substring(11, 16);
          element.notificationColor = notificationColor;
          element.message1 = message1;
          element.message2 = message2;
          element.messageNumber = messageNumber;
          element.messageArgument = messageArgument;
          element.remarks = remarks;
          element.underline = underline;
          element.bold = bold;
          // 表示リストに追加
          this.selectorList.push(element);
        }
      }

      // データを空にする
      if (notificationEmptyFlg) {
        this.displayLists = [];
      }
      setTimeout(() => {
        if (this.selectorList.length) {
          this.$refs.bottom.scrollIntoView({ behavior: 'instant' });
        }
      }, 300);
    },
    /**
     * 詳細はコチラ（カメラ）押下時のアクション
     * @param {object} item 通知情報
     */
    refreshIfCameraDetail(item) {
      if (this.cameraDetailFlag) {
        // this.$router.go({ path: this.$router.currentRoute.path, force: true });
        window.location.reload();
      } else {
        this.$store.commit('setDeviceID', {
          deviceID: item.deviceID,
        });
        this.$router.push('/cameraDetail');
      }
    },
    /**
     * 画面リロード
     */
    reset: function () {
      // this.$router.go({ path: this.$router.currentRoute.path, force: true });
      window.location.reload();
    },
    /**
     * メッセージにURLが含まれているかチェック
     * @param {string} str メッセージ
     * @returns {boolean} urlが存在する:メッセージに含まれているURL  urlが存在しない:null
     */
    getLink(str) {
      const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
      if (!str) return null;
      return str.match(regexpUrl) === null ? null : str.match(regexpUrl)[0];
    },
    /**
     * メッセージにURLが含まれているかチェック
     * @param {string} str メッセージ
     * @returns {boolean} urlが存在する:true  urlが存在しない:false
     */
    existsLink(str) {
      return this.getLink(str) === null ? false : true;
    },
    /**
     * 取得したURLからブラウザで開く
     * @description PC：別タブで開く  SP：ブラウザで開く
     * @param {string} str メッセージ
     */
    openLink(str) {
      if (this.$isMobileApp) {
        nativeApi.openBrowserApp(this.getLink(str));
      } else {
        window.open(this.getLink(str), '_blank');
      }
    },
    /**
     * 通知情報からカラーコードを取得
     * @param {string} colorString 色情報
     * @returns {string} カラーコード
     */
    getIconColor(colorString) {
      switch (colorString) {
        case 'red':
          return '#ea2e2e';
        case 'yellow':
          return '#fff200';
        case 'blue':
          return '#1d50a2';
        case 'green':
          return 'green';
        default:
          return 'white';
      }
    },
    /**
     * v-cardのclass名を取得
     * @param {string} colorString 色情報
     * @param {boolean} isPersonNotification 本人通知フラグ
     * @returns {string} class名
     */
    getCardColorAndPosition(colorString, isPersonNotification) {
      return (
        (isPersonNotification ? 'v-card-pc-right' : 'v-card-pc-left') +
        ' ' +
        this.getCardColor(colorString)
      );
    },
    /**
     * v-cardの色を取得
     * @param {string} colorString 色情報
     * @returns {string} 赤の場合：赤  他：空
     */
    getCardColor(colorString) {
      if (colorString == 'red') {
        return colorString;
      }
      return '';
    },
    /**
     * textの色を取得
     * @param {string} colorString 色情報
     * @returns {string} 赤の場合：赤  他：黒
     */
    getTextColor(colorString) {
      if (colorString == 'red') {
        return colorString + '--text';
      } else {
        return 'black' + '--text';
      }
    },
    /**
     * 詳細はコチラ（ホームセキュリティ）押下時のアクション
     * @param {object} item 通知情報
     */
    pushAlermConfirmation(item) {
      if (this.$router.currentRoute.path != '/displayDistrictDetail') {
        // 対象地区詳細の場合、遷移前に設定済みのため
        this.$store.commit('setCustomerNumber', {
          customerNumber: item.customerNumber,
        });
        this.$store.commit('setDistrictSplitNumber', {
          districtSplitNumber: item.districtSplitNumber,
        });
      }
      this.$router.push('/alermConfirmation');
    },
    /**
     * widthを調整
     * @param {object} width 幅
     */
    changeItemLabelWidth(width) {
      this.$emit('passEvent', width);
    },
    /**
     * 次ページ切替時にスクロールを一番上に移動
     */
    nextScroll() {
      this.$refs.top.scrollIntoView({ behavior: 'instant' });
      window.scrollTo({
        top: 0,
        behavior: 'instant',
      });
    },
    /**
     * 前ページ切替時にスクロールを一番下に移動
     */
    previousScroll() {
      this.$refs.bottom.scrollIntoView({ behavior: 'instant' });
    },
  },
  watch: {
    selectorList() {
      if (this.selectorList.length) {
        this.length = Math.ceil(this.selectorList.length / this.pageSize);
        if (this.selectorList.length % this.pageSize !== 0) {
          for (let i = 0; i < this.selectorList.length % this.pageSize; i++) {
            this.selectorList.unshift({});
          }
        }
        this.displayLists = this.selectorList.slice(
          this.pageSize * (this.page - 1),
          this.pageSize * this.page
        );

        this.page = Math.ceil(this.selectorList.length / this.pageSize);

        let elements = document.querySelectorAll('.v-pagination__navigation .v-icon');
        // there is total 8 elements because max tab of notification is 4 (notification history page) and each tab has 2 elements
        if (elements[0] != undefined) {
          elements[0].style.position = 'absolute';
          elements[0].style.top = '30px';
          elements[0].style.fontStyle = 'inherit';
          elements[0].style.fontSize = '18px';
          elements[0].style.left = '50%';
          elements[0].style.transform = 'translate(-50%, 25%)';
        }

        if (elements[1] != undefined) {
          elements[1].style.wordBreak = 'keep-all';
          elements[1].style.left = '50%';
          elements[1].style.transform = 'translate(0%, 25%)';
          elements[1].style.top = '-10px';
          elements[1].style.fontStyle = 'inherit';
          elements[1].style.fontSize = '18px';
        }

        if (elements[2] != undefined) {
          elements[2].style.position = 'absolute';
          elements[2].style.top = '30px';
          elements[2].style.fontStyle = 'inherit';
          elements[2].style.fontSize = '18px';
          elements[2].style.left = '50%';
          elements[2].style.transform = 'translate(-50%, 25%)';
        }

        if (elements[3] != undefined) {
          elements[3].style.wordBreak = 'keep-all';
          elements[3].style.left = '50%';
          elements[3].style.transform = 'translate(0%, 25%)';
          elements[3].style.top = '-10px';
          elements[3].style.fontStyle = 'inherit';
          elements[3].style.fontSize = '18px';
        }

        if (elements[4] != undefined) {
          elements[4].style.position = 'absolute';
          elements[4].style.top = '30px';
          elements[4].style.fontStyle = 'inherit';
          elements[4].style.fontSize = '18px';
          elements[4].style.left = '50%';
          elements[4].style.transform = 'translate(-50%, 25%)';
        }

        if (elements[5] != undefined) {
          elements[5].style.wordBreak = 'keep-all';
          elements[5].style.left = '50%';
          elements[5].style.transform = 'translate(0%, 25%)';
          elements[5].style.top = '-10px';
          elements[5].style.fontStyle = 'inherit';
          elements[5].style.fontSize = '18px';
        }

        if (elements[6] != undefined) {
          elements[6].style.position = 'absolute';
          elements[6].style.top = '30px';
          elements[6].style.fontStyle = 'inherit';
          elements[6].style.fontSize = '18px';
          elements[6].style.left = '50%';
          elements[6].style.transform = 'translate(-50%, 25%)';
        }

        if (elements[7] != undefined) {
          elements[7].style.wordBreak = 'keep-all';
          elements[7].style.left = '50%';
          elements[7].style.transform = 'translate(0%, 25%)';
          elements[7].style.top = '-10px';
          elements[7].style.fontStyle = 'inherit';
          elements[7].style.fontSize = '18px';
        }

        this.isShow = true;

        this.$refs.bottom.scrollIntoView({ behavior: 'instant' });
      }
    },
    displaySelectorList(newVal, oldVal) {
      if (newVal != oldVal) {
        (async () => {
          await this.listReset();
          if (this.$mq === 'sp') {
            await this.listReset();
          }
        })();
      }
    },
    homeSecurityChecked(newVal, oldVal) {
      if (newVal != oldVal) {
        (async () => {
          await this.listReset();
          await this.listReset();
          if (this.$mq === 'sp') {
            await this.listReset();
          }
        })();
      }
    },
    cameraChecked(newVal, oldVal) {
      if (newVal != oldVal) {
        (async () => {
          await this.listReset();
          await this.listReset();
          if (this.$mq === 'sp') {
            await this.listReset();
          }
        })();
      }
    },
    noticeChecked(newVal, oldVal) {
      if (newVal != oldVal) {
        (async () => {
          await this.listReset();
          await this.listReset();
          if (this.$mq === 'sp') {
            await this.listReset();
          }
        })();
      }
    },
    tabSelect(newVal, oldVal) {
      if (newVal != oldVal) {
        (async () => {
          await this.listReset();
          if (this.$mq === 'sp') {
            await this.listReset();
          }
        })();
      }
    },
  },
  async mounted() {
    (async () => {
      await this.listReset();
      await this.listReset();
    })();
  },
};
